import React, {useEffect, useState} from 'react';
import { now } from '../../dateUtils';
import Date from '../../ui/Date';
import GrayButtonNonTabs from '../../ui/GrayButton';
import InlineInputControlRow from '../../ui/layout/InlineInputControlRow';
import SecondaryButton from '../../ui/SecondaryButton';

function DateDialog({
  dateLabel,
  onOk,
  onCancel,
  initDate,
}: {
  dateLabel: string,
  onOk: (date:string|null) => {},
  onCancel: VoidFunction,
  initDate?: string|null,
}) {
  const [date, setDate] = useState<string|null>(initDate ?? now());

  useEffect(() => {
    const focusElement = document.getElementById('date-ctrl') as HTMLInputElement;
    if (focusElement) {
      setTimeout(() => {
        focusElement.focus();
        focusElement.select();
      }, 10);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{marginLeft: '20px'}}>
      <div style={{display: 'flex', height: '30px'}}>
        <div style={{width: '160px'}}>
          <InlineInputControlRow label={dateLabel} mode="w80">
            <Date dateId="date-ctrl" value={date} onChange={setDate} /> 
          </InlineInputControlRow>
        </div>
        <div style={{margin: 'auto'}}>
        </div>
        <div>
          <SecondaryButton style={{position: 'relative', top: '-5px', width: '60px'}} size="small" 
            onClick={async () => {
              const returnDate = await onOk(date);
              if (typeof returnDate === 'string' && returnDate) setDate(returnDate);   // 에러가 발생한 경우 Default Date값으로 설정
            }}>OK</SecondaryButton>
        </div>
      </div>
      <div style={{display: 'flex'}}>
        <div style={{margin: 'auto'}}>
        </div>
        <div>
          <GrayButtonNonTabs id="cancel-ctrl" style={{position: 'relative', top: '-5px', width: '60px'}} size="small" onClick={() => onCancel()}>Cancel</GrayButtonNonTabs>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DateDialog);
